<template>
  <transaction-list
    :transactionService = transactionService
    :productService = productService
    :externalMemberId = externalMemberId
  ></transaction-list>
</template>
<script>
  import TransactionList from '@/components/Common/Transaction/TransactionList'
  import transactionService from '@/services/slotting/transaction'
  import productService from '@/services/slotting/product'

  export default {
    components: {
      TransactionList
    },
    data () {
      return {
        transactionService: transactionService,
        productService: productService,
        externalMemberId: this.$route.params.external_member_id,
      }
    },

    created () {
      let externalMemberCode = this.$route.params.external_member_code || ''
      this.$store.commit('UPDATE_TITLE', 'Transactions' + ' ' + externalMemberCode)
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Slotting/Transactions/Overview.vue